"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var clause_1 = require("./../clause");
var lodash_1 = require("lodash");
var Optional = /** @class */ (function (_super) {
    __extends(Optional, _super);
    function Optional() {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this._optionalCollection = [];
        items.map(function (item) {
            _this._optionalCollection.push(item);
        });
        return _this;
    }
    Optional.prototype.addComponent = function (triple) {
        this._optionalCollection.push(triple);
    };
    Optional.prototype.build = function () {
        var selected = lodash_1.map(this._optionalCollection, function (item) {
            return item;
        });
        return "OPTIONAL {\n" + selected.slice().join(' .\n') + "\n}";
    };
    return Optional;
}(clause_1.Clause));
exports.Optional = Optional;
function optional() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return new (Optional.bind.apply(Optional, [void 0].concat(items)))();
}
exports.optional = optional;
